export default __webpack_public_path__ + "static/media/error.1c50c6ab.svg";